module.exports = __webpack_public_path__ + "img/shirt.05701df7.svg";